export default "__VITE_ASSET__dba2fda2__"